import { useLang } from "../i18n";
import { colors, fontHeading } from "../theme";

export default function CarFilters({ cars, filters, setFilters }) {
  const { t } = useLang();

  const uniq = (key) => Array.from(new Set(cars.map((c) => c[key]).filter(Boolean)));
  const brands = uniq("brand").sort();
  const bodyTypes = uniq("bodyType");
  const fuels = uniq("fuel");
  const transmissions = uniq("transmission");

  const update = (key) => (e) => setFilters((f) => ({ ...f, [key]: e.target.value }));
  const hasActiveFilters = Object.values(filters).some(Boolean);

  return (
    <div style={s.bar}>
      <select style={s.select} className="form-field" value={filters.brand} onChange={update("brand")}>
        <option value="">{t.filterAllBrands}</option>
        {brands.map((b) => (
          <option key={b} value={b}>
            {b}
          </option>
        ))}
      </select>

      <select style={s.select} className="form-field" value={filters.bodyType} onChange={update("bodyType")}>
        <option value="">{t.filterAllTypes}</option>
        {bodyTypes.map((v) => (
          <option key={v} value={v}>
            {t.bodyTypeVals[v] || v}
          </option>
        ))}
      </select>

      <select style={s.select} className="form-field" value={filters.fuel} onChange={update("fuel")}>
        <option value="">{t.filterAllFuels}</option>
        {fuels.map((v) => (
          <option key={v} value={v}>
            {t.fuelVals[v] || v}
          </option>
        ))}
      </select>

      <select style={s.select} className="form-field" value={filters.transmission} onChange={update("transmission")}>
        <option value="">{t.filterAllTransmissions}</option>
        {transmissions.map((v) => (
          <option key={v} value={v}>
            {t.transmissionVals[v] || v}
          </option>
        ))}
      </select>

      {hasActiveFilters && (
        <button
          style={s.clearBtn}
          className="link-hover"
          onClick={() => setFilters({ brand: "", bodyType: "", fuel: "", transmission: "" })}
        >
          {t.filterClear} ✕
        </button>
      )}
    </div>
  );
}

const s = {
  bar: {
    display: "flex",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 34,
    justifyContent: "center",
  },
  select: {
    background: colors.bgAlt,
    border: `1px solid ${colors.border}`,
    borderRadius: 6,
    color: colors.ink,
    padding: "10px 14px",
    fontSize: 13.5,
    fontFamily: fontHeading,
    fontWeight: 500,
    outline: "none",
    cursor: "pointer",
    minWidth: 150,
  },
  clearBtn: {
    background: "none",
    border: "none",
    color: colors.red,
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    fontFamily: fontHeading,
    padding: "10px 6px",
  },
};
